<template>
  <div>
    <b-row>
      <b-col>
        <div class="d-flex align-items-center">
          <span>Copy Other Nawala Slot Template</span>
          <v-select
            v-model="selectedTemplate"
            :options="templateList"
            class="ml-1 flex-fill mr-1"
            :reduce="x => x.code"
            label="Template to copy"
          >
            <template #no-options> There is template found </template>
          </v-select>

          <b-button class="ml-auto" @click="copyTemplate">Copy</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="match-height mt-1">
      <b-col cols="8"> </b-col>
      <b-col cols="4"> </b-col>
    </b-row>

    <b-modal v-model="modal.labelIntegrationHelp" size="lg" scrollable title="Label Integration Help" hide-footer>
      <label-integration-help />
    </b-modal>

    <b-modal
      v-model="modal.shortenerIntegrationHelp"
      size="lg"
      scrollable
      title="Shortener Integration Help"
      hide-footer
    >
      <shortener-integration-help />
    </b-modal>
  </div>
</template>

<script>
import js from "./integration";
export default js;
</script>
